<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .filename-container {
    display: flex;
    align-items: center;
    max-width: utils.in_rem(200px);

    .filename-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
</style>

<script>
  let { value, skeleton = false } = $props();
</script>

{#if skeleton}
  <span class:skeleton>Loading...</span>
{:else}
  <div class="filename-container">
    <span class="filename-text" title={value || "Unknown"}>
      {value || "Unknown"}
    </span>
  </div>
{/if}
